export const appInfo = {
  appName: 'Coin360',
  apiDomain: process.env.NEXT_PUBLIC_BASE_URL,
  websiteDomain: process.env.NEXT_PUBLIC_BASE_URL,
  apiBasePath: '/site-api/auth/',
  websiteBasePath: '/auth',
}
